'use client';

import { clientFetch } from '@/lib/api/clientFetch';
import { useEffect, useState } from 'react';
import { ProductRelatedSkeleton } from '../ProductDetailSkeleton';
import RelatedCarousel from './RelatedCarousel';

const MIN_SKELETON_MS = 520;

function readMessage(messages, path, fallback = '') {
  const resolved = path
    .split('.')
    .reduce((current, segment) => current?.[segment], messages);

  return typeof resolved === 'string' ? resolved : fallback;
}

export default function ProductRelatedSectionLoader({
  activeCoupons = [],
  messages = {},
  productNumber,
}) {
  const [isLoading, setIsLoading] = useState(true);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    let isCancelled = false;
    let timeoutId;

    async function loadProducts() {
      setIsLoading(true);
      const startedAt = performance.now();

      try {
        const payload = await clientFetch(
          `/api/products/${encodeURIComponent(productNumber)}/related`,
        );

        if (isCancelled) {
          return;
        }

        setProducts(Array.isArray(payload) ? payload : []);
      } catch {
        if (isCancelled) {
          return;
        }

        setProducts([]);
      } finally {
        const elapsed = performance.now() - startedAt;
        const remaining = Math.max(0, MIN_SKELETON_MS - elapsed);

        timeoutId = window.setTimeout(() => {
          if (!isCancelled) {
            setIsLoading(false);
          }
        }, remaining);
      }
    }

    loadProducts();

    return () => {
      isCancelled = true;
      window.clearTimeout(timeoutId);
    };
  }, [productNumber]);

  if (isLoading) {
    return <ProductRelatedSkeleton />;
  }

  if (!products.length) {
    return null;
  }

  return (
    <section className="app-section product-related-section">
      <div className="app-section__header">
        <span className="product-detail-panel__eyebrow">
          {readMessage(messages, 'relatedSectionEyebrow', 'Related picks')}
        </span>
      </div>
      <RelatedCarousel
        activeCoupons={activeCoupons}
        messages={messages}
        products={products}
      />
    </section>
  );
}
